export enum UserStatus {
    AllUsers = 1,
    ActiveUsers = 2,
    DeletedUsers = 3
}

export enum UserAvailability {
    Available = 0,
    Offline = 1,
    Away = 2,
    Invisible = 3,
}
